// Internal SLA helper (admin-only management tool). NOT shown to customers.
// Thresholds are internal first-response targets, not customer promises.
export const SLA_HOURS = { akutt: 2, hoy: 8, normal: 24 };

function fmtDur(ms) {
  if (ms < 0) ms = 0;
  const m = Math.floor(ms / 60000);
  const h = Math.floor(m / 60);
  const mm = m % 60;
  if (h > 0) return `${h}ч ${mm}м`;
  return `${mm}м`;
}

// Returns SLA state for a repair order using received_at (or created_at) and first_response_at.
export function computeSla(order) {
  const hours = SLA_HOURS[order.priority] ?? SLA_HOURS.normal;
  const thresholdMs = hours * 3600 * 1000;
  const startRaw = order.received_at || order.created_at;
  if (!startRaw) return null;
  const start = new Date(startRaw).getTime();
  const responded = !!order.first_response_at;

  if (responded) {
    const respMs = new Date(order.first_response_at).getTime() - start;
    const overdue = respMs > thresholdMs;
    return {
      hours, responded: true, overdue,
      state: overdue ? "over_responded" : "ok_responded",
      label: `Отвечено за ${fmtDur(respMs)}`,
      durationMs: respMs,
    };
  }
  // No response yet — count elapsed against threshold.
  const elapsedMs = Date.now() - start;
  const overdue = elapsedMs > thresholdMs;
  return {
    hours, responded: false, overdue,
    state: overdue ? "overdue_waiting" : "waiting",
    label: overdue ? `Просрочено на ${fmtDur(elapsedMs - thresholdMs)}` : `Ждёт ${fmtDur(thresholdMs - elapsedMs)}`,
    durationMs: elapsedMs,
  };
}

export const slaBadgeClass = {
  ok_responded: "bg-green-900/40 text-green-300 border-green-700/50",
  over_responded: "bg-amber-900/40 text-amber-300 border-amber-700/50",
  waiting: "bg-slate-700 text-slate-300 border-slate-600",
  overdue_waiting: "bg-red-900/40 text-red-300 border-red-700/50",
};
